"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var schema_1 = require("../data/schema");
var linkLayer_1 = require("../diagram/linkLayer");
var elements_1 = require("../diagram/elements");
var geometry_1 = require("../diagram/geometry");
var paper_1 = require("../diagram/paper");
var async_1 = require("../viewUtils/async");
var events_1 = require("../viewUtils/events");
var spinner_1 = require("../viewUtils/spinner");
var EditLayerMode;
(function (EditLayerMode) {
    EditLayerMode[EditLayerMode["establishLink"] = 0] = "establishLink";
    EditLayerMode[EditLayerMode["moveLinkSource"] = 1] = "moveLinkSource";
    EditLayerMode[EditLayerMode["moveLinkTarget"] = 2] = "moveLinkTarget";
})(EditLayerMode = exports.EditLayerMode || (exports.EditLayerMode = {}));
var EditLayer = /** @class */ (function (_super) {
    tslib_1.__extends(EditLayer, _super);
    function EditLayer(props) {
        var _this = _super.call(this, props) || this;
        _this.listener = new events_1.EventObserver();
        _this.cancellation = new async_1.Cancellation();
        _this.beginCreatingLink = function (params) {
            var model = _this.props.view.model;
            var sourceId = params.sourceId, point = params.point;
            var temporaryElement = _this.createTemporaryElement(point);
            var temporaryLink = model.addLink(new elements_1.Link({
                typeId: schema_1.PLACEHOLDER_LINK_TYPE,
                sourceId: sourceId,
                targetId: temporaryElement.id,
            }));
            var fatLinkType = model.createLinkType(temporaryLink.typeId);
            fatLinkType.setVisibility({ visible: true, showLabel: false });
            _this.temporaryElement = temporaryElement;
            _this.temporaryLink = temporaryLink;
        };
        _this.onMouseMove = function (e) {
            var targetElement = _this.state.targetElement;
            e.preventDefault();
            e.stopPropagation();
            var point = _this.props.paperArea.pageToPaperCoords(e.pageX, e.pageY);
            _this.temporaryElement.setPosition(point);
            var newTargetElement = _this.findElementFormPoint(point);
            if (newTargetElement && (!targetElement || newTargetElement.iri !== targetElement.iri)) {
                _this.canDropOnElement(newTargetElement);
            }
            _this.setState({ targetElement: newTargetElement });
        };
        _this.onMouseUp = function (e) {
            var _a = _this.props, editor = _a.editor, mode = _a.mode;
            var _b = _this.state, targetElement = _b.targetElement, canDropOnElement = _b.canDropOnElement, canDropOnCanvas = _b.canDropOnCanvas;
            editor.model.removeElement(_this.temporaryElement.id);
            if (targetElement || (mode === EditLayerMode.moveLinkSource || mode === EditLayerMode.moveLinkTarget)) {
                _this.endChangingLink({ link: _this.temporaryLink, targetElement: targetElement, canDrop: canDropOnElement }).then(function (link) {
                    if (link) {
                        editor.setSelection([link]);
                        editor.showEditLinkForm(link);
                    }
                });
            }
            else if (canDropOnCanvas) {
                var point_1 = _this.props.paperArea.pageToPaperCoords(e.pageX, e.pageY);
                var source_1 = editor.model.getElement(_this.temporaryLink.sourceId);
                _this.createNewElement(source_1.data).then(function (target) {
                    target.setPosition(point_1);
                    _this.endChangingLink({
                        link: _this.temporaryLink, targetElement: target, canDrop: canDropOnCanvas,
                    }).then(function (link) {
                        editor.setSelection([target]);
                        editor.showEditElementTypeForm({ link: link, source: source_1, target: target });
                    });
                });
            }
            editor.finishEditing();
        };
        _this.state = {};
        return _this;
    }
    EditLayer.prototype.componentDidMount = function () {
        var _a = this.props, mode = _a.mode, target = _a.target, point = _a.point;
        if (mode === EditLayerMode.establishLink) {
            this.beginCreatingLink({ sourceId: target.id, point: point });
        }
        else if (mode === EditLayerMode.moveLinkSource || mode === EditLayerMode.moveLinkTarget) {
            this.beginMovingLink({ link: target, point: point });
        }
        else {
            throw new Error('Unknown edit mode');
        }
        this.forceUpdate();
        this.canDropOnCanvas();
        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('mouseup', this.onMouseUp);
    };
    EditLayer.prototype.componentWillUnmount = function () {
        this.listener.stopListening();
        this.cancellation.abort();
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
    };
    EditLayer.prototype.beginMovingLink = function (params) {
        var _a = this.props, editor = _a.editor, mode = _a.mode;
        var link = params.link, point = params.point;
        this.oldLink = link;
        editor.model.removeLink(link.id);
        var id = link.id, typeId = link.typeId, sourceId = link.sourceId, targetId = link.targetId, data = link.data, vertices = link.vertices;
        var temporaryElement = this.createTemporaryElement(point);
        var temporaryLink;
        if (mode === EditLayerMode.moveLinkSource) {
            temporaryLink = editor.model.addLink(new elements_1.Link({
                id: id, typeId: typeId, sourceId: temporaryElement.id, targetId: targetId, data: data, vertices: vertices,
            }));
        }
        else if (mode === EditLayerMode.moveLinkTarget) {
            temporaryLink = editor.model.addLink(new elements_1.Link({
                id: id, typeId: typeId, sourceId: sourceId, targetId: temporaryElement.id, data: data, vertices: vertices,
            }));
        }
        else {
            throw new Error('Unknown edit mode');
        }
        this.temporaryElement = temporaryElement;
        this.temporaryLink = temporaryLink;
    };
    EditLayer.prototype.createTemporaryElement = function (point) {
        var temporaryElement = this.props.view.model.createTemporaryElement();
        temporaryElement.setPosition(point);
        return temporaryElement;
    };
    EditLayer.prototype.canDropOnCanvas = function () {
        var _this = this;
        var _a = this.props, mode = _a.mode, editor = _a.editor, metadataApi = _a.metadataApi;
        if (!metadataApi || mode !== EditLayerMode.establishLink) {
            this.setState({ canDropOnCanvas: false });
            return;
        }
        this.setState({ canDropOnCanvas: undefined });
        var source = editor.model.getElement(this.temporaryLink.sourceId).data;
        metadataApi.canDropOnCanvas(source, this.cancellation.signal).then(function (canDropOnCanvas) {
            if (!_this.cancellation.signal.aborted) {
                _this.setState({ canDropOnCanvas: canDropOnCanvas });
            }
        });
    };
    EditLayer.prototype.canDropOnElement = function (targetElement) {
        var _this = this;
        var _a = this.props, mode = _a.mode, editor = _a.editor, metadataApi = _a.metadataApi;
        if (!metadataApi) {
            this.setState({ canDropOnElement: false });
            return;
        }
        this.setState({ canDropOnElement: undefined });
        var source;
        var target;
        if (mode === EditLayerMode.establishLink || mode === EditLayerMode.moveLinkTarget) {
            source = editor.model.getElement(this.temporaryLink.sourceId).data;
            target = targetElement.data;
        }
        else if (mode === EditLayerMode.moveLinkSource) {
            source = targetElement.data;
            target = editor.model.getElement(this.temporaryLink.targetId).data;
        }
        metadataApi.canDropOnElement(source, target, this.cancellation.signal).then(function (canDropOnElement) {
            if (!_this.cancellation.signal.aborted) {
                _this.setState({ canDropOnElement: canDropOnElement });
            }
        });
    };
    EditLayer.prototype.endChangingLink = function (params) {
        var _a = this.props, editor = _a.editor, mode = _a.mode;
        var link = params.link, targetElement = params.targetElement, canDrop = params.canDrop;
        var originalLink;
        editor.model.removeLink(link.id);
        if (this.oldLink) {
            originalLink = editor.model.addLink(this.oldLink);
        }
        if (mode === EditLayerMode.establishLink) {
            var sourceElement = editor.model.getElement(link.sourceId);
            if (canDrop && targetElement) {
                return this.createNewLink(sourceElement, targetElement);
            }
        }
        else if (mode === EditLayerMode.moveLinkSource) {
            if (canDrop && targetElement) {
                return Promise.resolve(editor.moveLinkSource({ link: link, newSource: targetElement }));
            }
        }
        else if (mode === EditLayerMode.moveLinkTarget) {
            if (canDrop && targetElement) {
                return Promise.resolve(editor.moveLinkTarget({ link: link, newTarget: targetElement }));
            }
        }
        else {
            throw new Error('Unknown edit mode');
        }
        return Promise.resolve(originalLink);
    };
    EditLayer.prototype.createNewElement = function (source) {
        var _a = this.props, editor = _a.editor, metadataApi = _a.metadataApi;
        if (!metadataApi) {
            return Promise.resolve(undefined);
        }
        return metadataApi.typesOfElementsDraggedFrom(source, this.cancellation.signal).then(function (elementTypes) {
            var type = elementTypes.length === 1 ? elementTypes[0] : schema_1.PLACEHOLDER_ELEMENT_TYPE;
            return editor.createNewEntity(type);
        });
    };
    EditLayer.prototype.createNewLink = function (source, target) {
        var _a = this.props, editor = _a.editor, metadataApi = _a.metadataApi;
        if (!metadataApi) {
            return Promise.resolve(undefined);
        }
        return metadataApi.possibleLinkTypes(source.data, target.data, this.cancellation.signal).then(function (linkTypes) {
            var typeId = linkTypes.length === 1 ? linkTypes[0] : schema_1.PLACEHOLDER_LINK_TYPE;
            var link = new elements_1.Link({
                typeId: typeId,
                sourceId: source.id,
                targetId: target.id,
                data: {
                    linkTypeId: typeId,
                    sourceId: source.iri,
                    targetId: target.iri,
                },
            });
            return editor.createNewLink(link);
        });
    };
    EditLayer.prototype.findElementFormPoint = function (point) {
        var elements = this.props.view.model.elements;
        for (var i = elements.length - 1; i >= 0; i--) {
            var element = elements[i];
            var _a = geometry_1.boundsOf(element), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
            if (element.temporary) {
                continue;
            }
            if (point.x >= x && point.x <= x + width && point.y >= y && point.y <= y + height) {
                return element;
            }
        }
        return undefined;
    };
    EditLayer.prototype.renderHighlight = function () {
        var _a = this.state, targetElement = _a.targetElement, canDropOnElement = _a.canDropOnElement;
        if (!targetElement) {
            return null;
        }
        var _b = geometry_1.boundsOf(targetElement), x = _b.x, y = _b.y, width = _b.width, height = _b.height;
        if (canDropOnElement === undefined) {
            return (React.createElement("g", { transform: "translate(" + x + "," + y + ")" },
                React.createElement("rect", { width: width, height: height, fill: 'white', fillOpacity: 0.5 }),
                React.createElement(spinner_1.Spinner, { size: 30, position: { x: width / 2, y: height / 2 } })));
        }
        var stroke = canDropOnElement ? '#5cb85c' : '#c9302c';
        return (React.createElement("rect", { x: x, y: y, width: width, height: height, fill: 'transparent', stroke: stroke, strokeWidth: 3 }));
    };
    EditLayer.prototype.renderCanDropIndicator = function () {
        var _a = this.state, targetElement = _a.targetElement, canDropOnCanvas = _a.canDropOnCanvas;
        if (targetElement) {
            return null;
        }
        var _b = this.temporaryElement.position, x = _b.x, y = _b.y;
        var indicator;
        if (canDropOnCanvas === undefined) {
            indicator = React.createElement(spinner_1.Spinner, { size: 1.2, position: { x: 0.5, y: -0.5 } });
        }
        else if (canDropOnCanvas) {
            indicator = React.createElement("path", { d: 'M0.5,0 L0.5,-1 M0,-0.5 L1,-0.5', strokeWidth: 0.2, stroke: '#5cb85c' });
        }
        else {
            indicator = (React.createElement("g", null,
                React.createElement("circle", { cx: '0.5', cy: '-0.5', r: '0.5', fill: 'none', strokeWidth: 0.2, stroke: '#c9302c' }),
                React.createElement("path", { d: 'M0.5,0 L0.5,-1', strokeWidth: 0.2, stroke: '#c9302c', transform: 'rotate(-45 0.5 -0.5)' })));
        }
        return (React.createElement("g", { transform: "translate(" + x + " " + y + ")scale(40)" },
            React.createElement("rect", { x: -0.5, y: -0.5, width: 1, height: 1, fill: 'rgba(0, 0, 0, 0.1)', rx: 0.25, ry: 0.25 }),
            React.createElement("g", { transform: "translate(" + 0.5 + ", -" + 0.5 + ")scale(" + 0.25 + ")" }, indicator)));
    };
    EditLayer.prototype.render = function () {
        var _a = this.props, view = _a.view, paperTransform = _a.paperTransform;
        if (!this.temporaryLink) {
            return null;
        }
        return (React.createElement(paper_1.TransformedSvgCanvas, { paperTransform: paperTransform, style: { overflow: 'visible' } },
            React.createElement(linkLayer_1.LinkMarkers, { view: view }),
            this.renderHighlight(),
            this.renderCanDropIndicator(),
            React.createElement(linkLayer_1.LinkLayer, { view: view, links: [this.temporaryLink] })));
    };
    return EditLayer;
}(React.Component));
exports.EditLayer = EditLayer;
function isPlaceholderElementType(target) {
    return target === schema_1.PLACEHOLDER_ELEMENT_TYPE;
}
exports.isPlaceholderElementType = isPlaceholderElementType;
function isPlaceholderLinkType(target) {
    return target === schema_1.PLACEHOLDER_LINK_TYPE;
}
exports.isPlaceholderLinkType = isPlaceholderLinkType;
